import { PlatformService } from './PlatformService';
import { SupportedCompanies } from './Tags';

export const isApparel = () => PlatformService.match(SupportedCompanies.APPAREL);
export const isGameBreaker = () => PlatformService.match(SupportedCompanies.GAMEBREAKER);
export const isP3inc = () => PlatformService.match(SupportedCompanies.P3INC);
